import React from 'react';
import FontAwesome from 'react-fontawesome';

import styles from './WeekView.less';

const CrewTag = ({ active, crew, onCrewSelect }) => crew
  ? (
    <div className={[styles.crewTag, active ? styles.active : ''].join(' ')} onClick={onCrewSelect}>
      <FontAwesome name="square" style={{ color: crew && crew.equipment && crew.equipment.color ? crew.equipment.color : '#fafafa' }} /> {crew.equipment ? crew.equipment.name : 'No Equipment'}<br />
      {crew.resources.filter(r => !!r.resource).map(r => (
        <span key={r.resource.id}>{r.resource.firstName} {r.resource.lastName} <br /></span>
      ))}
    </div>
  )
  : (
    <div className={[styles.crewTag, active ? styles.active : ''].join(' ')} onClick={onCrewSelect}>Unassigned</div>
  );

export default CrewTag;
